module.exports = __webpack_public_path__ + "static/img/dians.b30513a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dians.png
// module id = 87s6
// module chunks = 128